export const STANDARD_META_AUDIENCE_FIELDS = [
  "id",
  "name",
  "client_id",
  "audience_type_id",
  "audience_type",
  "premium",
  "long_description",
  "audience_issues",
  "created_by_id",
  "shared_with",
  "audience_category",
  "audience_category_id",
  "audience_topic",
  "audience_topic_id",
  "uses_fec_donor_data",
] as const;
